import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { Paper, Grid, Typography } from "@material-ui/core";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import EventIcon from "@material-ui/icons/Event";
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  documentSelectBox: {
    textTransform: "capitalize",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  panCard: {
    background: "#fff",
    borderRadius: 16,
    padding: "24px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    margin: "20px 5%",
  },

  infoBox: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },

  iconBox: {
    width: 60,
    height: 60,
    borderRadius: 12,
    background: "#EEF9F2",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  icon: {
    color: "#18A558",
    fontSize: 30,
  },

  label: {
    color: "#666",
    fontSize: 12,
    marginBottom: 4,
  },

  value: {
    color: "#163A70",
    fontWeight: 700,
    fontSize: 16,
  },

  borderRight: {
    borderRight: "1px solid #E5E7EB",
    padding: "0px 20px",
    "@media (max-width:960px)": {
      borderRight: "none",
      marginTop: 20,
    },
  },
}));

const UpdatePanDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { mobileNumber } = useSelector((state) => state.login.userData);
  const [panName, setPanName] = useState("");
  const [dob, setDob] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [loanDisbursed, setLoanDisbursed] = useState(false);
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
      getUserLoanDetails();
  }, []);

  const getUserLoanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_USER_LOAN_DETAILS_API + mobileNumber,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code === 401) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const data = result?.data?.filter((item) => item.status === "COMPLETED");
      if (data?.length > 0) {
        setLoanDisbursed(true);
      }
      getPanDetails();
    }
  };

  const getPanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_USER_PAN_DETAILS_API + mobileNumber,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setPanNumber(result?.data?.panNumber);
      setPanName(result?.data?.name);
      setDob(result?.data?.dob);
    }
  };
  const initiatPaymnet = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_UPDATE_PAN_CARD_API,
      method: "POST",
      authToken: authToken,
      data: {
        mobileNumber: mobileNumber,
        panNumber: panNumber.toUpperCase(),
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      navigate("/panDetails");
    }
  };
  const isFormValid = () => {
    if (!panName || !panNumber || !dob) return false;
    return true;
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <SubHeader
          label="Pan Details"
          button1={loanDisbursed ? "" : "Update"}
          button1click={loanDisbursed ? "" : initiatPaymnet}
          disabled1={!isFormValid()}
          noButton
        />
      </Grid>
      {loanDisbursed ? (
        <Grid item xs={12}>
          <Paper className={classes.panCard}>
            <Grid container alignItems="center">
              <Grid item xs={12} md={4} className={classes.borderRight}>
                <div className={classes.infoBox}>
                  <div className={classes.iconBox}>
                    <CreditCardIcon className={classes.icon} />
                  </div>

                  <div>
                    <Typography className={classes.label}>
                      PAN Card Number
                    </Typography>

                    <Typography className={classes.value}>
                      {panNumber || "-"}
                    </Typography>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} md={4} className={classes.borderRight}>
                <div className={classes.infoBox}>
                  <div className={classes.iconBox}>
                    <PersonOutlineIcon className={classes.icon} />
                  </div>

                  <div>
                    <Typography className={classes.label}>Name</Typography>

                    <Typography className={classes.value}>
                      {panName || "-"}
                    </Typography>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} md={4} className={classes.borderRight}>
                <div className={classes.infoBox}>
                  <div className={classes.iconBox}>
                    <EventIcon className={classes.icon} />
                  </div>

                  <div>
                    <Typography className={classes.label}>
                      Date of Birth
                    </Typography>

                    <Typography className={classes.value}>
                      {dob || "-"}
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      ) : (
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer}>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="PanCard Number"
                placeholder="PanCard Number"
                value={panNumber}
                onChange={(e) => setPanNumber(e.target.value)}
                style={classes.inputField}
                disabled={loanDisbursed}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="Name"
                placeholder="Name"
                value={panName}
                onChange={(e) => setPanName(e.target.value)}
                style={classes.documentSelectBox}
                disabled={loanDisbursed}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="Date of Birth"
                placeholder="Date of Birth"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                style={classes.documentSelectBox}
                disabled={loanDisbursed}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default UpdatePanDetails;
